module.exports = __webpack_public_path__ + "ec1d490e23e4a9b5ce8b4d48696cce23.svg";